var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E5B6A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.786 8.855h15.428m-15.43 3.542h15.424M5.786 15.94h15.422"
  })));
};
export default SvgDrag;